// extracted by mini-css-extract-plugin
export default {"wrapper":"e4a7a223a070","invoices":"e5b5734b3dd5","offlineInvoiceFootnote":"ef7631d04f89"};